import styled from 'styled-components';

export const Wrapper = styled.div`
  background: rgba(235, 235, 235, 0.95);
  height: calc(100vh - 152px);
  overflow-y: auto;
  padding-top: 1.25em;
  position: fixed;
  right: 0;
  top: 152px;
  width: 328px;
  z-index: 3000;
`;
